import type { AppointmentForm } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';

import {
  HorizontalFlex,
  VerticalFlex,
} from '@components/RecordCard/RecordCard.style';

const CommandLayout = ({ ...props }: AppointmentForm.CommandLayoutProps) => {
  const {
    onCancelButtonClick,
    onCommitButtonClick,
    onDeleteButtonClick,
    commandButtonComponent: Button,
  } = props;
  return (
    <HorizontalFlex
      justifyContent="flex-end"
      marginBottom={0}
      marginLeft={12}
      marginTop={0}
      width="100%"
    >
      <VerticalFlex alignItems="flex-end" justifyContent="flex-end">
        <Button id="deleteButton" onExecute={onDeleteButtonClick} />
      </VerticalFlex>
      <VerticalFlex alignItems="flex-end" justifyContent="flex-end">
        <Button id="saveButton" onExecute={onCommitButtonClick} />
      </VerticalFlex>
      <VerticalFlex
        alignItems="flex-end"
        justifyContent="flex-end"
        paddingLeft={20}
        paddingRight={12}
      >
        <Button id="cancelButton" onExecute={onCancelButtonClick} />
      </VerticalFlex>
    </HorizontalFlex>
  );
};

export default CommandLayout;
